<div class="lookup-security-wrapper">
    <div class="list-actions-container">
        <div class="actions-container">
            <edx-segment [items]="segmentItems" [value]="segmentItems[0]['value']" [id]="'usergroups'"
                (change)="listSelected($event)"></edx-segment>
            <div class="searchBoxSection">
                <div class="search-bar" [title]="translationMap.search">
                    <input #searchGroup [placeholder]="translationMap['search']" class="search-text" [(ngModel)]="searchValue"
                        (keyup)="clearSearchWhenEmpty($event)" (keyup.enter)="searchClicked($event)" type="text"
                        id="search" name="search" />
                    @if (searchValue) {
                    <div role="button" id="search_clr_btn" [title]="translationMap.clear" tabindex="0" class="icon clear"
                       (keyup.space)="searchClear($event)" (keyup.enter)="searchClear($event)" (click)="searchClear($event)"></div>
                    }
                    <div role="button" id="search_btn" tabindex="0" class="icon search" [title]="translationMap.search"
                        (keyup.space)="searchClicked($event)" (keyup.enter)="searchClicked($event)" (click)="searchClicked($event)">
                    </div>
                </div>
            </div>
        </div>
        <div class="list-container">
            <edx-list-table #lookupTable [desc]="listDesc" [lookupForm]="listKind" [parent]="this"
                [formType]="formType" [lookupKey]="lookupKey" [schemaId]="schemaId" [leadingColums]="leadingColumns" [inlineActionMenuId]="6" [inlineActionTarget]="this"></edx-list-table>
        </div>
        <div class="list-actions-buttons">
            <button (click)="denySelection()" (keydown)="onKeyDown($event, 'deny')" class="secondary" title="{{ translationMap.deny }}" [ngClass]="{readonly: !enableDeny()}" [disabled]="!enableDeny()" tabindex="0" id="edx_btn_deny">{{ translationMap.deny }}</button>
            <button (click)="allowSelection()" (keydown)="onKeyDown($event, 'allow')" class="secondary" title="{{ translationMap.allow }}" [ngClass]="{readonly: !enableAllow()}" [disabled]="!enableAllow()" tabindex="0" id="edx_btn_allow">{{ translationMap.allow }}</button>
        </div>
    </div>
    <div class="access-container">
        <div class="allowed-list-container chicklets" id="edx_allowed_list_container" [title]="translationMap['allowed']" tabindex="0" [attr.aria-label]="getAriaLabel('allowed')" role="list" (keydown)="onKeyDown($event)">
            <div class="header-parent">
                <div class="allowed-list-header">{{translationMap.allowed}}</div>
                @if(allowedList.length > 0) {
                    <div role="button" class="clr-btn" [title]="this.translationMap.clear + ' ' + this.translationMap.allowedList" (click)="clearList($event, 'allowed')" tabindex="0" (keyup.space)="clearList($event, 'allowed')" (keyup.enter)="clearList($event, 'allowed')"></div>
                }
            </div>
            <div class="allowed-items-list">
                @for (allowed of allowedList; track allowed) {
                <div class="allowed-item chicklet" title="{{ allowed['USER_ID'] }}" tabindex="0" (keydown)="onKeyDown($event)" role="listitem" [attr.aria-label]="getAriaLabelForChiclet(allowed)">
                    <img class="itemicon" src={{getChicletIcon(allowed)}}>
                    <span class="celltext">{{ allowed['USER_ID'] }}</span>
                    <span class="del" role="button" (click)="removeFromAllowed(allowed)"
                        (keydown.space)="removeFromAllowed(allowed)" (keydown.enter)="removeFromAllowed(allowed)" tabindex="0" [title]="this.translationMap.remove + ' ' + allowed['USER_ID']"></span>
                </div>
                }
            </div>
        </div>
        <div class="denied-list-container chicklets" [title]="translationMap['denied']" tabindex="0" id="edx_denied_list_container" (keydown)="onKeyDown($event)" [attr.aria-label]="getAriaLabel('denied')" role="list" >
            <div class="header-parent">
                <div class="denied-list-header">{{translationMap.denied}}</div>
                @if(deniedList.length > 0) {
                    <div role="button" class="clr-btn" (click)="clearList($event, 'denied')" (keyup.space)="clearList($event, 'denied')" (keyup.enter)="clearList($event, 'denied')"  tabindex="0" [title]="this.translationMap.clear + ' ' + this.translationMap.deniedList"></div>
                }
            </div>
            <div class="denied-items-list">
                @for (denied of deniedList; track denied) {
                <div class="denied-item chicklet" title="{{ denied['USER_ID'] }}" role="listitem" tabindex="0" [attr.aria-label]="getAriaLabelForChiclet(denied)">
                    <img class="itemicon" src={{getChicletIcon(denied)}}>
                    <span class="celltext">{{ denied['USER_ID'] }}</span>
                    <span class="del" role="button" tabindex="0" (click)="removeFromDenied(denied)"
                        (keydown.space)="removeFromDenied(denied)" (keydown.enter)="removeFromDenied(denied)" [title]="this.translationMap.remove + ' ' + denied['USER_ID']"></span>
                </div>
                }
            </div>
        </div>
    </div>
</div>